import _ from 'lodash';

import RefData from 'ref-data';

import EmailIntegrationsCollection from './email-integrations-collection';
import EmailIntegrationsModel from './email-integrations-model';

import { ajaxService } from '../../common/Services';
import { ApiUtils } from '../../common/api';
import IntegrationTemplateCollection from './integration-template-collection';

function fetchNotificationList(experienceId, accountId) {
  return ajaxService
    .get('/api/integration/list.json', {
      containerRef: `campaign:${accountId}:${experienceId}`,
      typeRef:      RefData.Enum.TYPE.INTEGRATION.EMAIL,

      order: 'desc',
      sort:  'id',
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(EmailIntegrationsCollection.deserialize);
}

function removeNotification(emailTemplateId) {
  return ajaxService
    .post('/api/integration/delete.json', {
      id: emailTemplateId,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract);
}

function disableNotification(emailTemplateId) {
  return ajaxService
    .get('/api/integration/disable.json', {
      id: emailTemplateId,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(EmailIntegrationsModel.deserialize);
}

function enableNotification(emailTemplateId) {
  return ajaxService
    .get('/api/integration/enable.json', {
      id: emailTemplateId,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(EmailIntegrationsModel.deserialize);
}

function fetchTemplateEmailList(experience) {
  return ajaxService
    .get('/api/integrationtemplate/list.json', {
      typeRef:  RefData.Enum.TYPE.INTEGRATION.EMAIL,
      validFor: experience.typeRef.id,
      status:   RefData.Enum.STATUS.INTEGRATIONTEMPLATE.ACTIVE,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(IntegrationTemplateCollection.deserialize);
}

function fetchNewEmailTemplate(templateEmailId, experienceId, accountId) {
  return ajaxService
    .get('/api/integration/createFromTemplate.json', {
      templateId:   templateEmailId,
      containerRef: `campaign:${accountId}:${experienceId}`,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(EmailIntegrationsModel.deserialize);
}

function updateEmailTemplate(emailTemplate) {
  const serializedTemplate = EmailIntegrationsModel.serialize(emailTemplate);

  return ajaxService
    .post('/api/emailtemplate/update.json', {
      id:             serializedTemplate.id,
      instanceConfig: JSON.stringify(serializedTemplate.instanceConfig),
      name:           serializedTemplate.name,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(EmailIntegrationsModel.deserialize);
}

function checkEmailTemplateTokens(emailTemplate, campaignObjectId) {
  return ajaxService
    .post('/api/emailtemplate/preview.json', {
      campaignObjectId,
      emailTemplate: JSON.stringify(emailTemplate),
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1);
}

function fetchCampaignTokenList(experienceId) {
  return ajaxService
    .get('/api/emailtemplate/tokenList.json', {
      campaignObjectId: experienceId,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract);
}

function sendPreviewEmailTemplate(emailTo, emailTemplate, campaignId) {
  const _emailTemplate = _.cloneDeep(emailTemplate);
  delete _emailTemplate._fromAddress;
  delete _emailTemplate._fromDomain;

  return ajaxService
    .post('/api/emailtemplate/previewAndSend.json', {
      emailTo:       emailTo,
      emailTemplate: JSON.stringify(_emailTemplate),
      campaignId,
    })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract);
}

export default {
  fetchNotificationList,
  removeNotification,
  disableNotification,
  enableNotification,
  fetchTemplateEmailList,
  fetchNewEmailTemplate,
  updateEmailTemplate,
  checkEmailTemplateTokens,
  fetchCampaignTokenList,
  sendPreviewEmailTemplate,
};
